import { CommonModule } from '@angular/common';
import { Component, Inject } from '@angular/core';
import { FormsModule } from '@angular/forms';
import { MatButtonModule } from '@angular/material/button';
import {
  MAT_DIALOG_DATA,
  MatDialogModule,
  MatDialogRef,
} from '@angular/material/dialog';
import { MatFormFieldModule } from '@angular/material/form-field';
import { MatInputModule } from '@angular/material/input';
import { MatProgressSpinnerModule } from '@angular/material/progress-spinner';
import {
  normalizeSupportTicketReporterLocale,
  SupportTicketSource,
} from '@nx-c4g/c4g-models';
import { TranslateModule, TranslateService } from '@ngx-translate/core';
import { notify } from '../notify-drawer/notify';
import { SupportTicketService } from './support-ticket.service';

export interface SupportTicketDialogData {
  source: SupportTicketSource;
}

@Component({
  selector: 'nx-c4g-support-ticket-dialog',
  standalone: true,
  imports: [
    CommonModule,
    FormsModule,
    MatDialogModule,
    MatButtonModule,
    MatFormFieldModule,
    MatInputModule,
    MatProgressSpinnerModule,
    TranslateModule,
  ],
  templateUrl: './support-ticket-dialog.component.html',
  styleUrls: ['./support-ticket-dialog.component.scss'],
})
export class SupportTicketDialogComponent {
  subject = '';
  description = '';
  submitting = false;

  constructor(
    private readonly dialogRef: MatDialogRef<SupportTicketDialogComponent, boolean>,
    @Inject(MAT_DIALOG_DATA) public readonly data: SupportTicketDialogData,
    private readonly supportTicketService: SupportTicketService,
    private readonly translate: TranslateService
  ) {}

  cancel(): void {
    this.dialogRef.close(false);
  }

  async submit(): Promise<void> {
    const subject = this.subject?.trim();
    const description = this.description?.trim();
    if (!subject || !description) {
      notify(
        this.translate.instant('supportTickets.toast.fieldsRequired'),
        'warning',
        3500
      );
      return;
    }
    this.submitting = true;
    try {
      await this.supportTicketService.submit({
        subject,
        description,
        source: this.data.source,
        reporterLocale: normalizeSupportTicketReporterLocale(
          this.translate.currentLang
        ),
      });
      notify(
        this.translate.instant('supportTickets.toast.sentThanks'),
        'info',
        3500
      );
      this.dialogRef.close(true);
    } catch {
      notify(
        this.translate.instant('supportTickets.toast.sendFailed'),
        'error',
        4000
      );
    } finally {
      this.submitting = false;
    }
  }
}
